import { useCallback } from 'react';
import { useCopyToClipBoard } from 'utils/useCopyToClipBoard';
import { useReferralLinkRequest } from 'modules/client/shareReferralLink/hooks/useReferralLinkRequest';
import { getErrorHandler } from 'utils/getErrorHandler';

export const useShareLink = () => {
  const { getRefLink, isLoading: isReferralLinkLoading } =
    useReferralLinkRequest();
  const copyToClipboard = useCopyToClipBoard();

  const handleShareLink = useCallback(
    async (userId) => {
      try {
        const referralLink = await getRefLink(userId);

        copyToClipboard(referralLink);
      } catch (error) {
        getErrorHandler('Unable to get referral link');
      }
    },
    [copyToClipboard, getRefLink],
  );

  return {
    handleShareLink,
    isReferralLinkLoading,
  };
};
